// Ultimate Card Game (UCG) - Deck Archetypes
//
// Neustart "Marine Null": every preset deck except one was removed. The
// remaining "Standard" deck is derived from js/data/cards.js's `enabled`
// flags at load time via getActiveCards() - so re-enabling a card there
// automatically makes it drawable here too, no second place to update.
// See NEUSTART_PLAN.html Phase 1.

import { getActiveCards } from './cards.js';

function buildHumanDeck() {
  const active = getActiveCards().filter(c => c.race === 'Human');
  return {
    id: "Human",
    name: "Human Vanguard",
    race: "Human",
    badge: "Marine Corps",
    icon: "assets/cards/Marine_1.png",
    description: "All active Human cards. Cards are automatically included here as they are enabled in cards.js.",
    common: active.filter(c => c.tier === 1).map(c => c.name),
    uncommon: active.filter(c => c.tier === 2).map(c => c.name),
    epic: active.filter(c => c.tier === 3).map(c => c.name)
  };
}

function buildSulDeck() {
  const active = getActiveCards().filter(c => c.race === 'Sul');
  return {
    id: "Sul",
    name: "Sul Swarm",
    race: "Sul",
    badge: "The Swarm",
    icon: "assets/cards/1_defectiveloaf.png",
    description: "All active Sul cards. Biomechanical symbiotic alien swarm.",
    common: active.filter(c => c.tier === 1).map(c => c.name),
    uncommon: active.filter(c => c.tier === 2).map(c => c.name),
    epic: active.filter(c => c.tier === 3).map(c => c.name)
  };
}

export const DECKS_DATA = {
  "Human": buildHumanDeck(),
  "Sul": buildSulDeck()
};

// Backward-compatibility alias for "Standard" (non-enumerable so Object.keys(DECKS_DATA) returns strictly ["Human", "Sul"])
Object.defineProperty(DECKS_DATA, 'Standard', {
  get() { return DECKS_DATA.Human; },
  enumerable: false,
  configurable: true
});

Object.defineProperty(DECKS_DATA, 'Sul Swarm', {
  get() { return DECKS_DATA.Sul; },
  enumerable: false,
  configurable: true
});

Object.defineProperty(DECKS_DATA, 'Human Vanguard', {
  get() { return DECKS_DATA.Human; },
  enumerable: false,
  configurable: true
});
